// extracted by mini-css-extract-plugin
export default {"container":"SuccessQrUpdated_container__2PUK4","title":"SuccessQrUpdated_title__SAROc"};